import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ArrowRightIcon } from 'lucide-react';
import { platformFeatures } from '../data/home';
interface PlatformShowcaseProps {
  onOpenDemo: () => void;
}
export function PlatformShowcase({
  onOpenDemo
}: PlatformShowcaseProps) {
  return <section id="platform" className="bg-cool-gray py-24 md:py-32" data-id="element-175" data-mp="1po4jq4a2k9se">
      <div className="max-w-7xl mx-auto px-6" data-id="element-176" data-mp="1pmtgc5kjd41t">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-177" data-mp="1203fh7jxbfis">
          <motion.div initial={{
          opacity: 0,
          x: -24
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7,
          ease: 'easeOut'
        }} className="space-y-8" data-id="element-178" data-mp="wzyup5bzfymr">
            <span className="text-royal-blue text-xs font-bold uppercase tracking-[0.2em]" data-id="element-179" data-mp="e9r1pg1zyoka">
              ROI Complete Platform
            </span>
            <h2 className="text-midnight-navy text-3xl md:text-5xl font-montserrat font-extrabold leading-tight tracking-tight" data-id="element-180" data-mp="1i5m42ccelu0b">
              Real-time visibility across every location you operate.
            </h2>
            <p className="text-midnight-navy/60 text-lg leading-relaxed" data-id="element-181" data-mp="1ry1mfarm4klq">
              One platform for the numbers that drive your business — from daily
              sales and labor to food cost, purchasing, and vendor performance.
            </p>

            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-id="element-182" data-mp="145kvsbtt7kat">
              {platformFeatures.map((feature, idx) => <motion.li key={feature} initial={{
              opacity: 0,
              x: -10
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: idx * 0.05
            }} className="flex items-center gap-3 text-midnight-navy font-medium" data-id="element-183" data-mp="186eij1vimt24" data-mpi={idx}>
                  <span className="w-5 h-5 rounded-full bg-royal-blue/10 text-royal-blue flex items-center justify-center shrink-0" data-id="element-184" data-mp="yhm7ins69vtf">
                    <CheckIcon className="w-3 h-3" data-id="element-185" data-mp="th8b62zxoab8" />
                  </span>
                  {feature}
                </motion.li>)}
            </ul>

            <button onClick={onOpenDemo} className="group inline-flex items-center gap-2 text-royal-blue font-bold hover:gap-3 transition-all" data-id="element-186" data-mp="vyn718zr3y9">
              Request a platform demo
              <ArrowRightIcon className="w-4 h-4" data-id="element-187" data-mp="aqgt8d1vrbl8" />
            </button>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.96
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="relative" data-id="element-188" data-mp="3j6aa4t04ip2t">
            <img src="https://cdn.magicpatterns.com/patterns/generated-images/d46ece62-cca1-4219-bed9-f9b419f739ab.jpg" alt="ROI Complete platform dashboards showing sales analytics, food cost and multi-location reporting" className="w-full h-auto rounded-2xl shadow-2xl shadow-midnight-navy/15 border border-midnight-navy/5" data-id="element-189" data-mp="1os4rktm6qpbn" />
            <div className="absolute -top-5 -right-5 hidden sm:flex flex-col bg-midnight-navy text-stark-white rounded-2xl shadow-xl px-6 py-4" data-id="element-190" data-mp="23j5c3x07i9o5">
              <span className="text-[10px] font-bold uppercase tracking-widest text-stark-white/40" data-id="element-191" data-mp="s1mdkhxkmuvx">
                AI Insight
              </span>
              <span className="font-montserrat font-bold" data-id="element-192" data-mp="wyvz3mhuameh">
                Food cost trending up 1.8%
              </span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}